import { PropsWithChildren } from "react";

import classes from "./DashboardChartFrame.module.css";

/** Fixed chart height. The page scrolls; the plot does not grow to the fold. */
export const DashboardChartFrame = ({ children }: PropsWithChildren) => {
  return <div className={classes.frame}>{children}</div>;
};
